// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__2IByV","isBlue":"style_isBlue__UvALX"};